import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  httpHeaderOptions: any;

  constructor(public _http: HttpClient) {
    this.httpHeaderOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }
  }

  getRoles(str) {
    return this._http.get(environment.apiEndpoint + 'module-role_relation-mapping/' + str + '/', this.httpHeaderOptions);
  }

  roleList() {
    return this._http.get(environment.apiEndpoint + 'module-role_create/', this.httpHeaderOptions);
  }

  roleMasterList(app) {
    return this._http.get(environment.apiEndpoint + 'roles_by_module_name/' + app + '/', this.httpHeaderOptions);
  }

  addRole(str) {
    return this._http.post(environment.apiEndpoint + 'module-role_create/', str, this.httpHeaderOptions);
  }

  addUserRole(data) {
    return this._http.post(environment.apiEndpoint + 'module_role_create_new/', data, this.httpHeaderOptions);
  }

  updateRole(id, str) {
    return this._http.put(environment.apiEndpoint + 'edit_role/' + id + '/', str, this.httpHeaderOptions);
  }

  cloneRoles(str) {
    return this._http.post(environment.apiEndpoint + 'clone_module-roles/' + str.clone_from + '/' + str.clone_to + '/', '', this.httpHeaderOptions);
  }

  reportingto(roleid, moduleid) {
    return this._http.get(environment.apiEndpoint + 'role_dropdown_reporing_to/' + roleid + '/' + moduleid + '/', this.httpHeaderOptions);
  }

  changereporting(roleid, moduleid, str) {
    return this._http.put(environment.apiEndpoint + 'change_reporing_to/' + roleid + '/' + moduleid + '/', str, this.httpHeaderOptions);
  }

  getObjects(moduleid, parentid) {
    return this._http.get(environment.apiEndpoint + 'other_list_by_parent/' + moduleid + '/' + parentid + '/', this.httpHeaderOptions);
  }

  getOtherListForRole(moduleid, id, parentRoleId) {
    if (parentRoleId > 0) {
      return this._http.get(environment.apiEndpoint + 'other_list_for_role/' + moduleid + '/?parent_role_id=' + parentRoleId + '&role_id=' + id, this.httpHeaderOptions);
    }
    else {
      return this._http.get(environment.apiEndpoint + 'other_list_for_role/' + moduleid + '/?role_id=' + id, this.httpHeaderOptions);
    }

  }

  assignPermission(data) {
    return this._http.post(environment.apiEndpoint + 'assign_permission_to_role_add_or_update/', data, this.httpHeaderOptions);
  }

  getImmidiatePositionByRole(roleID) {
    return this._http.get(environment.apiEndpoint + 'get_immidiate_position_by_role/' + roleID + '/', this.httpHeaderOptions);
  }

  assignRolePermission(data) {
    return this._http.post(environment.apiEndpoint + 'assign_permission_to_role_add_or_update_new/', data, this.httpHeaderOptions);
  }

  getRolePermission(app, role) {
    return this._http.get(environment.apiEndpoint + 'other_list_with_permission_by_role_module_name/' + app + '/' + role + '/', this.httpHeaderOptions);
  }

  getRoleDetails(id) {
    return this._http.get(environment.apiEndpoint + 'edit_role/' + id + '/', this.httpHeaderOptions);
  }

}
